import { Component, OnInit } from '@angular/core';
import { MotiesService } from '../../services/moties.service';

@Component({
  selector: 'app-motions',
  templateUrl: './motions.component.html',
  styleUrls: ['./motions.component.scss'],
})
export class MotionsComponent implements OnInit {
  motions: any[] = [];
  document: any = window.document;
  motionsToDisplay: any[] = [];
  progressEmoji: string[] = [
    '/assets/img/icon-smiley-red.svg',
    '/assets/img/icon-smiley-orange.svg',
    '/assets/img/icon-smiley-green.svg',
  ];
  selectedTab = 1;
  multipleStatus = false;

  constructor(private service: MotiesService) {}

  ngOnInit() {
    this.service.get().subscribe(a => {
      this.motions = a;
      this.motionsToDisplay = this.motions;
      const unique = [...Array.from(new Set(this.motions.map(item => item.Status)))];
      console.log(unique);
      this.multipleStatus = unique.length > 1;
    });
  }

  switchView(tab) {
    this.selectedTab = tab;
    switch (this.selectedTab) {
      case 1:
        this.motionsToDisplay = this.motions;
        break;
      case 2:
        this.motionsToDisplay = this.motions.filter(a => a.Status === 0);
        break;
      case 3:
        this.motionsToDisplay = this.motions.filter(a => a.Status === 1);
        break;
      default:
        break;
    }
  }

  openFile(m) {
    if (!m.url) {
      return false;
    }

    this.document.location.href = m.url;
  }
}



// WEBPACK FOOTER //
// ./src/app/components/motions/motions.component.ts